import ApiService from '../api.service'

const main = '/list-announcement'

const EnnounsmentService = {

    getList: async function (params) {
        for (const key in params) {
            if (params[key] == null || params[key] == 'null' || params[key] == undefined)  params[key]=''
        }
        var requestData = {
            method: 'post',
            url: `${main}?depId=${params.depId}&staffPositionId=${params.staffPositionId}&locationTypeId=${params.locationTypeId}`,
            data: params.params,
        };
        try {
            return await ApiService.customRequest(requestData);

        } catch (error) {
            return error.response.data
        }
    },

    getArchiveList: async function (params) {
        for (const key in params) {
            if (params[key] == null || params[key] == 'null' || params[key] == undefined)  params[key]=''
        }
        var requestData = {
            method: 'post',
            url: `/archive${main}?depId=${params.depId}&staffPositionId=${params.staffPositionId}&locationTypeId=${params.locationTypeId}`,
            data: params.params,
        };
        try {
            return await ApiService.customRequest(requestData);

        } catch (error) {
            return error.response.data
        }
    },
    getListLocationType: async function () {
        return ApiService.get(`list-staff-position`)
    },
    getListStaffPosition: async function () {
        return ApiService.get(`list-location-type`)
    },
    getVacancyList: async function (params) {
        return ApiService.post(`list-staffListVacancy/${params.id}`, params.data)
    },
    getVacancyListLogin: async function (params) {
        return ApiService.post(`employee/list-staffListVacancy/${params.id}`, params.data)
    },
}

export default EnnounsmentService;
